export const entityModels = [
	"USER",
	"SOCIETY",
	"CONSTRUCTION_SITE",
	"PROPOSITION",
	"QUITTANCE",
	"GFA_CONSTRUCTION_SITE",
] as const;


export const templateTypes = [
	"CONVENTION_APPORTEUR",	
	"CONTRAT_STANDARD",
	"RAPPORT_EXPERTISE",
	"DEVIS",
	"PROPOSITION_ASSURANCE_DO",
	"PROPOSITION_ASSURANCE_TRC",
	"PROPOSITION_ASSURANCE_MRT",
	"PROPOSITION_ASSURANCE_GFA",
	"CONDITIONS_GENERALES_DO",
	"CONDITIONS_GENERALES_TRC",
	"CONDITIONS_GENERALES_MRT",
	"CONDITIONS_GENERALES_GFA",
	"INDICATION_TARIFAIRE_DO_AXERIA",
	"INDICATION_TARIFAIRE_TRC_AXERIA",
	"INDICATION_TARIFAIRE_DO_CARAVELA",
	"INDICATION_TARIFAIRE_TRC_CARAVELA",
	"INDICATION_TARIFAIRE_MRT_ZURICH",
	"CONTRAT_ASSURANCE_DO",
	"CONTRAT_ASSURANCE_TRC",
	"CONTRAT_ASSURANCE_MRT",
	"CONTRAT_ASSURANCE_GFA",
	"QUITTANCE_DO",
	"QUITTANCE_TRC",
	"QUITTANCE_MRT",
	"QUITTANCE_GFA",
	"ATTESTATION_DEFINITIVE_DO",
	"ATTESTATION_DEFINITIVE_TRC",
	"ATTESTATION_DEFINITIVE_MRT",
	"ATTESTATION_DEFINITIVE_GFA",
	"AVENANT_FIN_DE_TRAVAUX_DO",
	"AVENANT_FIN_DE_TRAVAUX_TRC",
	"AVENANT_FIN_DE_TRAVAUX_MRT",
	"AVENANT_FIN_DE_TRAVAUX_GFA",
	"QUITTANCEMENT_RECEPTION_DO",
	"QUITTANCEMENT_RECEPTION_TRC",
	"QUITTANCEMENT_RECEPTION_MRT",
	"QUITTANCEMENT_RECEPTION_GFA",

	"DEVIS_GFA",
	"RAPPORT_EXPERTISE_GFA",
	"INDICATION_TARIFAIRE_GFA_CARAVELA",
] as const;

export const indicationTarifaireTemplateTypes: Record<string, typeof templateTypes[number]> =  {
	DO_AXERIA: "INDICATION_TARIFAIRE_DO_AXERIA",
	TRC_AXERIA: "INDICATION_TARIFAIRE_TRC_AXERIA",
	DO_CARAVELA: "INDICATION_TARIFAIRE_DO_CARAVELA",
	TRC_CARAVELA: "INDICATION_TARIFAIRE_TRC_CARAVELA",
	MRT_ZURICH: "INDICATION_TARIFAIRE_MRT_ZURICH",
	GFA_CARAVELA: "INDICATION_TARIFAIRE_GFA_CARAVELA",
} as const;

export enum SignatureMethodEnum {
	ELECTRONIC = "ELECTRONIC",
	MANUAL = "MANUAL",
}

export const DOCUSIGN_RECIPIENT_ID = {
	BROKER: "1",
	DUNE: "2",
} as const;


export const ENTITY_TEMPLATE_MAPPINGS: Record<string, string[]> = {
	SOCIETY: ["CONVENTION_APPORTEUR", "CONTRAT_STANDARD"],
	CONSTRUCTION_SITE: [
		"DEVIS",
		"RAPPORT_EXPERTISE",

		"INDICATION_TARIFAIRE_DO_AXERIA",
		"INDICATION_TARIFAIRE_TRC_AXERIA",
		"INDICATION_TARIFAIRE_DO_CARAVELA",
		"INDICATION_TARIFAIRE_TRC_CARAVELA",
		"INDICATION_TARIFAIRE_MRT_ZURICH",
	],
	PROPOSITION: [
		"PROPOSITION_ASSURANCE_DO",
		"PROPOSITION_ASSURANCE_TRC",
		"PROPOSITION_ASSURANCE_MRT",
		"PROPOSITION_ASSURANCE_GFA",
		"CONDITIONS_GENERALES_DO",
		"CONDITIONS_GENERALES_TRC",
		"CONDITIONS_GENERALES_MRT",
		"CONDITIONS_GENERALES_GFA",
		"CONTRAT_ASSURANCE_DO",
		"CONTRAT_ASSURANCE_TRC",
		"CONTRAT_ASSURANCE_MRT",
		"CONTRAT_ASSURANCE_GFA",
		"ATTESTATION_DEFINITIVE_DO",
		"ATTESTATION_DEFINITIVE_TRC",
		"ATTESTATION_DEFINITIVE_MRT",
		"ATTESTATION_DEFINITIVE_GFA",
		"AVENANT_FIN_DE_TRAVAUX_DO",
		"AVENANT_FIN_DE_TRAVAUX_TRC",
		"AVENANT_FIN_DE_TRAVAUX_MRT",
		"AVENANT_FIN_DE_TRAVAUX_GFA",
	],
	USER: ["CONTRAT_STANDARD"],
	GFA_CONSTRUCTION_SITE: ["DEVIS_GFA", "RAPPORT_EXPERTISE_GFA", "INDICATION_TARIFAIRE_GFA_CARAVELA"],
	QUITTANCE: [
		"QUITTANCE_DO",
		"QUITTANCE_TRC",
		"QUITTANCE_MRT",
		"QUITTANCE_GFA",
		"QUITTANCEMENT_RECEPTION_DO",
		"QUITTANCEMENT_RECEPTION_TRC",
		"QUITTANCEMENT_RECEPTION_MRT",
		"QUITTANCEMENT_RECEPTION_GFA",
	],
};